import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { formatDateLocal } from 'utils/date';
import { sortByDate } from 'utils/sort';
import { capitalizeFirstLetterLowercaseOthers } from 'utils/string';

import { LABELS } from '../../keys';
import { OrderPwcSectionProps } from '../../types';
import { Item, ItemValue, SectionWrapper } from '../styles';
import { CheckIcon, StyledItemName } from './styles';

export const OrderStatusHistorySection = ({ orderData }: OrderPwcSectionProps) => {
  const { t } = useTranslation();
  const statusHistory = orderData.general.statusTransitionHistory;
  const sortedStatusHistory = sortByDate(statusHistory, (s) => s.createdAt, 'asc');

  return (
    <Panel label={t(LABELS.SECTIONS.ORDER_STATUS_HISTORY.TITLE)}>
      <SectionWrapper>
        {sortedStatusHistory.map((status) => (
          <Item key={`${status.createdAt}-${status.to}`}>
            <StyledItemName>
              <CheckIcon width={16} height={16} />
              {capitalizeFirstLetterLowercaseOthers(status.to)}
            </StyledItemName>
            <ItemValue>{formatDateLocal(status.createdAt)}</ItemValue>
          </Item>
        ))}
      </SectionWrapper>
    </Panel>
  );
};
